export default __webpack_public_path__ + "static/media/Televisa.387b0888.jpg";